import { createSlice } from "@reduxjs/toolkit";
import { dictService } from "../../services/dictService";
import { createCustomAsyncThunk, defaultEntityAdapter } from "../utils";

export const getEmployees = createCustomAsyncThunk(
    "dicts/employees/get",
    async params => await dictService.getEmployees(params)
)

const employeesSlice = createSlice({
    name: "dicts/employees",
    initialState: defaultEntityAdapter.getInitialState({
        isLoading: false,
        error: null
    }),
    extraReducers: builder => {
        builder
            .addCase(getEmployees.pending, state => { state.isLoading = true })
            .addCase(getEmployees.fulfilled, (state, action) => {
                defaultEntityAdapter.setAll(state, action.payload)
                state.isLoading = false
            })
            .addCase(getEmployees.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error
            })
    }
})

export const employeeSelectors = defaultEntityAdapter.getSelectors(x => x.dicts.employees)

export default employeesSlice.reducer